import React from 'react';
import { CardWrapper } from './styles';
import { DynamicObjectType } from 'core/types/common';
import TotalOrderItem from '../components/TotalOrderItem';
import { Space } from 'antd';
import { formatDateStr, formatMoney } from 'core/helper/formatString';
import ReturnInformation from './ReturnInformation';
import Validation from './Validation';
import { sumBy } from 'lodash';
// import ReturnInformation from './ReturnInformation';

const RightContent = ({ data }: { data: DynamicObjectType }) => {
  return (
    <Space size={20} direction="vertical" className="w-full">
      {['AWAITING_CONFIRMATION'].includes(data?.status) && (
        <Validation data={data} />
      )}
      <CardWrapper title="Related Orders">
        <Space size={15} direction="vertical" className="w-full">
          <TotalOrderItem
            title="Return Orders"
            value={`#${data?.orderReturn?.returnNumber || data?.orderReturn?.id || '-'}`}
            titleClass="text-[--text-title-gray] font-bold text-sm"
            valueClass="text-[--primary] text-sm"
            isLink
            href={`/orders-return/${data?.orderReturn?.id}/show`}
          />
          <TotalOrderItem
            title="Order"
            value={`#${data?.newOrder?.orderNumber || data?.newOrder?.id || '-'}`}
            titleClass="text-[--text-title-gray] font-bold text-sm"
            valueClass="text-[--primary] text-sm"
            isLink
            href={`/order-management/${data?.newOrder?.id}/show`}
          />
        </Space>
      </CardWrapper>
      <CardWrapper title="Customer Information">
        <div>
          <div className="order-info-box__content">
            <div className="order-info-box__content-item color-dark-gray mb-[5px]">
              {data?.customer
                ? `${data?.customer?.firstName} ${data?.customer?.lastName}`
                : data?.address?.customerName}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
              {data?.customer?.email || data?.address?.email}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50">
              {data?.customer?.telephone || data?.address?.telephone}
            </div>
          </div>
        </div>
      </CardWrapper>
      <CardWrapper title="Original Order">
        <Space size={15} direction="vertical" className="w-full">
          <TotalOrderItem
            title="Order No."
            value={`${data?.originalOrder?.orderNumber || data?.originalOrder?.orderId || '-'}`}
            valueClass="font-bold text-sm"
            isLink
            href={`/order-management/${data?.originalOrder?.orderId}/show`}
          />
          <TotalOrderItem
            title="Order created time"
            value={`${data?.originalOrder?.createdAt ? formatDateStr(data?.originalOrder?.createdAt) : '-'}`}
            valueClass="font-bold text-sm"
          />
          <TotalOrderItem
            title="Number of items"
            value={`${sumBy(data?.originalOrder?.items, 'quantity') || 0}`}
            valueClass="font-bold text-sm"
          />
          <TotalOrderItem
            title="Amount"
            value={`${formatMoney(data?.originalOrder?.total || 0)}`}
            valueClass="font-bold text-sm"
          />
        </Space>
      </CardWrapper>
      <ReturnInformation
        data={data?.orderReturn}
        title="Return Information"
        address={data?.orderReturn?.pickupInformation}
      />
      <ReturnInformation
        data={data?.newOrder}
        title="Shipping Information"
        address={data?.newOrder?.address}
      />
    </Space>
  );
};

export default RightContent;
